import CodeBlock from '../components/CodeBlock';

export default function Screenshot() {
  return (
    <section id="screenshot" className="mb-16">
      <h3 className="text-2xl font-bold text-gray-900 mb-4">POST /screenshot</h3>
      <p className="text-gray-700 mb-6">
        Capture a screenshot of any website with customizable options for viewport size,
        format, and quality.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mb-3">Basic Example</h4>
      <CodeBlock section="basic" />

      <div className="mt-6">
        <h4 className="text-lg font-semibold text-gray-900 mb-3">Full Page Screenshot</h4>
        <p className="text-gray-700 mb-3">
          Capture the entire scrollable height of a webpage:
        </p>
        <CodeBlock section="fullPage" />
      </div>
    </section>
  );
}